export const isInHost = () => {
    if (window.__IS_HOST__ === true) return true;
    if (window.parent !== window) return true;
    if (sessionStorage.getItem("wasInHost") === "true") return true;

    if (document.referrer && document.referrer.includes(window.location.hostname)) {
        sessionStorage.setItem("wasInHost", "true");
        return true;
    }

    return false;
};

// ✅ Clean + safe URL update
export const updateURL = (params) => {
    const cleanParams = Object.fromEntries(
        Object.entries(params)
            .filter(([_, value]) => {
                if (value === null || value === undefined) return false;
                if (typeof value === "string" && value.trim() === "") return false;
                if (Array.isArray(value) && value.length === 0) return false;
                return true;
            })
            .map(([key, value]) => {
                if (Array.isArray(value)) {
                    return [key, value.join(",")];
                }
                return [key, value];
            })
    );

    const query = new URLSearchParams(cleanParams).toString();
    const newUrl = `${window.location.pathname}?${query}`;

    // ✅ ALWAYS update local URL (IMPORTANT)
    window.history.pushState({}, "", newUrl);

    // ✅ notify React/UI
    window.dispatchEvent(new Event("urlChange"));

    // ✅ ALSO notify host (if exists)
    if (window.__IS_HOST__ === true) {
        window.parent.postMessage(
            {
                type: "UPDATE_URL",
                payload: cleanParams,
            },
            "*"
        );
    }
};

// ✅ Safe reader (no "null"/"undefined" strings)
export const getURLParams = () => {
    const params = new URLSearchParams(window.location.search);

    const clean = (val) => {
        if (!val || val === "null" || val === "undefined") return undefined;
        return val;
    };

    return {
        tab: clean(params.get("tab")),
        type: clean(params.get("type")),
        dept_code: clean(params.get("dept_code")),
        trade_mode: clean(params.get("trade_mode")),
        ship_mode: clean(params.get("ship_mode")),
    };
};
export const updateSimpleURL = ({ tab, type }) => {
    const basePath = "/";

    const params = new URLSearchParams();

    if (tab) params.set("tab", tab);
    if (type) params.set("type", type);

    const url = `${basePath}?${params.toString()}`;
    // console.log(url, 'url check')

    window.history.pushState({}, "", url);
};